import * as http from '@utils/baseRequest';
import {host} from '@utils/hostConf';

export async function fetchPatientList(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/family/queryuserfamily',
    data,
  });
}

export async function fetchPatientDetail(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/family/queryuserfamilydetail',
    data,
  });
}

export async function addPatient(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/family/adduserfamily',
    data,
  });
}

export async function editPatient(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/family/modifyuserfamily',
    data,
  });
}

export async function updateDefPatient(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/family/setdefaultuserfamily',
    data,
  });
}

export async function delPatient(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/family/deleteuserfamily',
    data,
  });
}

export async function fetchImgCode(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/user/getpicsecurity',
    data,
  });
}

//用户注册,请求验证码
export async function fetchSmsCode(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/user/sendsecuritycodemessage',
    data,
  });
}

//第三方注册, 给第三方id进行绑定和注册
export function reqRegThird(data) {
  return http.post({
    url: host.goapi + 'user/handler/thirdRegist',
    data,
  });
}

//第三方登录 使用第三方给的id进行登录
export function reqLoginThird(data) {
  return http.post({
    url: host.goapi + 'user/handler/thirdLogin',
    data,
  });
}

//钉钉用户判断输入内容
export const actReqDTUser = (value) => {
  let post = {
    page_size: 10
  };
  if (/^[0-9]+$/.test(value)) {
    post.phone = +value;
  } else {
    post.name = value;
  }
  return reqDTUser(post);
};

//钉钉用户搜索
export const reqDTUser = (data) => {
  return http.get({url: `${host.cas}api/get_dt_users`, data})
};

// 获取关注状态
export function getFollowStatus(data) {
	return http.post({url: `${host.omoVideo}/omoApi/user/getFollowStatus`, data})
}

const UPLOAD_SCENE = '13';
// 上传oss 获取签名
export const getToken = (file_type, scene)  => {
  return http.post({url: `${host.goapi}oss/handler/GenToken`, data: {file_type, scene: scene || UPLOAD_SCENE}});
};